import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UnidadesDeNegocioService {

  unidadesDeNegocio = [
    'Almacén Central'
  ];

  constructor() { }
}
